import React, { useEffect, useState } from "react";
import {
  Create,
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  useRedirect,
  useRefresh,
  useDataProvider,
  CreateProps,
  NumberInput,
  minValue,
  maxValue,
} from "react-admin";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import CustomEndDateInput from "components/CustomEndDateInput";
import CustomRegistrationDateInput, {
  EType,
} from "components/CustomRegistrationDateInput";
import CustomDatePickerInput from "./components/CustomDatePickerInput";
import moment from "moment";

const AcademicYearCreate = (props: CreateProps) => {
  const [academicYears, setAcademicYears] = useState<IAcademicYear[]>([]);
  const provider = useDataProvider();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const param = GetParam();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    {
      title: "Academic Years",
      link: `/schools/${param.get("schoolId")}/show/4`,
    },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = (props: { data: IAcademicYear }) => {
    redirect(`/schools/${props.data.schoolId}/show/4`);
    refresh();
  };

  //fetch area data for current school on first load
  useEffect(() => {
    provider
      .getList("academicYears", {
        filter: { SchoolId: Number(param.get("schoolId")) },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then(({ data }) => {
        setAcademicYears(data as IAcademicYear[]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let excludeDates: IExcludeDates[] = [];
  academicYears.forEach((academicYear: IAcademicYear) => {
    let temp: IExcludeDates = {
      startDate: academicYear.startDate,
      endDate: academicYear.endDate,
    };

    excludeDates.push(temp);
  });

  const transform = async (data: any) => {
    data.basicRates = [];

    return data;
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <Typography variant="h4">New Academic Year</Typography>
      <Create onSuccess={CustomRedirect} {...props} transform={transform}>
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">School</Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <TextInput
                source="name"
                label="Academic Year"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <CustomDatePickerInput
                name="startDate"
                label="Start Date"
                // min={moment().format("yyyy-MM-DD")}
                excludeDates={excludeDates}
                isReset
              />
            </Grid>

            <Grid item xs={4}>
              <CustomEndDateInput
                source="endDate"
                label="End Date"
                comparison="startDate"
                excludeDates={excludeDates}
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <CustomRegistrationDateInput
                source="earlyRegistrationStartDate"
                type={EType.Early}
                label="Early Registration Start Date"
              />
            </Grid>
            <Grid item xs={4}>
              <CustomRegistrationDateInput
                source="earlyRegistrationEndDate"
                comparison="earlyRegistrationStartDate"
                type={EType.Early}
                label="Early Registration End Date"
              />
            </Grid>
            <Grid item xs={4}>
              <CustomRegistrationDateInput
                source="lateRegistrationStartDate"
                type={EType.Late}
                label="Late Registration Start Date"
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Refund Rate (%)</Typography>
            </Grid>

            <Grid item xs={4}>
              <NumberInput
                source="refundRate"
                label="Refund Rate (%)"
                validate={[required(), minValue(0), maxValue(100)]}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </Create>
    </>
  );
};

export default AcademicYearCreate;
